// @flow

import api from "api";
import * as resources from "resources";
import Auth from "@aws-amplify/auth";
import type { RegisterDto } from "routes/register/Register/types";

/**
 * We use this function to intercept all secure calls in the private app.
 * We add bearer token into our headers here.
 */
export function intercept() {
  api.interceptors.request.use((config) => {
    return new Promise((resolve, reject) => {
      Auth.currentSession()
        .then((user) => {
          config.headers = {
            ...config.headers,
            ...{ Authorization: "Bearer " + user.idToken.jwtToken },
          };
          resolve(config);
        })
        .catch((err) => {
          reject("Not currently logged in: " + err);
        });
    });
  });
}

export function getCurrentUser(): Promise<any> {
  return new Promise((resolve, reject) => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        // Attach authorization to requests
        intercept();

        // Get the ICPC user associated with the Cognito user
        let email = user.attributes.email;
        api
          .get(resources.DataGET.PERSON_BY_USERNAME(email))
          .then((icpcUser) => {
            const currentUser =
              icpcUser && icpcUser.data
                ? {
                    loggedIn: icpcUser.data,
                    email: icpcUser.data.userName,
                    fullName: `${icpcUser.data.firstName} ${icpcUser.data.lastName}`,
                    firstName: icpcUser.data.firstName,
                    lastName: icpcUser.data.lastName,
                    uid: icpcUser.data.id,
                  }
                : { loggedIn: false, icpcUserNotFound: true, email: email };
            resolve(currentUser);
          })
          // TODO figure out how to handle errors when bad auth ID (ex. on backups)
          .catch((err) => {
            resolve({ loggedIn: false, email: email });
          });
      })
      .catch((err) => {
        resolve({ loggedIn: false });
      });
  });
}

export const registerUser = (dto: RegisterDto) => {
  return api.post(resources.DataPOST.PERSON_REGISTER, dto);
};

export const fetchRoles = () => {
  return api.get(resources.DataGET.USER_ROLES);
};

export const updateUsername = (personId: number, dto: Object) => {
  return api.post(resources.DataPOST.PERSON_USERNAME_CHANGE(personId), dto);
};
